import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=40215b2a&scoped=true"
import script from "./AddTemplate.vue?vue&type=script&lang=js"
export * from "./AddTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=40215b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40215b2a",
  null
  
)

export default component.exports